import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../styles/blogs.css";

const BACKEND_URL = "https://ddmwrl2uut5q8.cloudfront.net";

const Blogs = () => {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    fetch(`${BACKEND_URL}/api/blogs`)
      .then((res) => res.json())
      .then((data) => setBlogs(Array.isArray(data) ? data : []))
      .catch((err) => {
        console.error("Error fetching blogs:", err);
        setBlogs([]);
      });
  }, []);

  return (
    <div className="blogs-container">
      <h2>Blogs Posts</h2>
      <div className="blogs-grid">
        {blogs.map((blog) => (
          <div key={blog.id} className="blog-card">
            <img
              src={
                blog.image
                  ? `${BACKEND_URL}${blog.image}`
                  : "/images/placeholder-blog.jpg"
              }
              alt={blog.title}
              title="blog"
              className="blog-image"
            />
            <div className="blog-content">
              <h3 className="blog-title">{blog.title}</h3>
              <p className="blog-meta">
                <strong>By:</strong> {blog.author} &nbsp; | &nbsp;
                <strong>Date:</strong> {blog.date}
              </p>
              <p className="blog-excerpt">
                {blog.content
                  ?.replace(/<[^>]+>/g, "") // remove HTML tags
                  .substring(0, 100) + "..."}
              </p>
              <Link to={`/blogs/${blog.id}`} className="read-more">
                Read more
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Blogs;
